<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18 4.99963H6C5.447 4.99963 5 5.44763 5 5.99963V10.9996H7L6.999 8.99863L10 8.99963V16.9986L8 16.9996V18.9996H16V16.9996H14V8.99963H17V10.9996H19V5.99963C19 5.44763 18.553 4.99963 18 4.99963Z"/>
</svg>
